/* eslint-disable */

// 枚举合集
export default {
  allPageSize: 999999,
  // 地区类别
  AreaType: {
    // 枚举列表
    list: [
      { label: "洲", value: 1 },
      { label: "国", value: 2 },
      { label: "省", value: 3 },
      { label: "市", value: 4 },
      { label: "区/县", value: 5 },
    ],
    allList() {
      return this.list;
    },
    forModelList: [
      { label: "国家", value: 2 },
      { label: "省际", value: 3 },
      { label: "城市", value: 4 }
    ],
    forEventList: [
      { label: "全球性", value: 0 },
      { label: "洲际性", value: 1 },
      { label: "全国性", value: 2 },
      { label: "省际性", value: 3 },
      { label: "城市性", value: 4 }
    ],
    // 根据枚举值获取名称
    getName(val) {
      let retVal = ''
      let findIndex = this.list.findIndex(item => item.value == val )
      if (findIndex > -1) {
        retVal = this.list[findIndex].label
      }

      return retVal
    },
    // 根据枚举值获取名称
    getForModeName(val) {
      let retVal = ''
      let findIndex = this.forModelList.findIndex(item => item.value == val )
      if (findIndex > -1) {
        retVal = this.forModelList[findIndex].label
      }

      return retVal
    }
  },
  ModelTargetType: {
    list: [
      { label: "通用", value: 1 },
      { label: "华人", value: 2 }
    ],
    // 根据枚举值获取名称
    getName(val) {
      let retVal = ''
      let findIndex = this.list.findIndex(item => item.value == val )
      if (findIndex > -1) {
        retVal = this.list[findIndex].label
      }

      return retVal
    }
  },
  EventRelatedLevel: {
    list: [
      { label: "低", value: 0 },
      { label: "一般", value: 1 },
      { label: "中等", value: 2 },
      { label: "较高", value: 3 },
      { label: "极高", value: 4 },
    ]
  },

  // 数据采集源资讯分类
  CollectSourceType: {
    list: [
      { label: "媒体网站", value: 1 },
      { label: "门户网站", value: 2 },
      { label: "社交网站", value: 3 },
      { label: "政府网站", value: 4 }
    ],
    // 根据枚举值获取名称
    getName(val) {
      let retVal = ''
      let findIndex = this.list.findIndex(item => item.value == val )
      if (findIndex > -1) {
        retVal = this.list[findIndex].label
      }

      return retVal
    }
  },

  // 数据采集源资讯处理状态
  CollectSourceStatus: {
    list: [
      { label: "待处理", value: 0 },
      { label: "已处理", value: 1 },
      { label: "已删除", value: 2 }
    ]
  },

  // 涉华人数分类数组
  InvolvedType: {
    list: [
      { key: "death", text: "死亡" },
      { key: "injured", text: "受伤" },
      { key: "death_and_injured", text: "伤亡" },
      { key: "missing", text: "失踪" },
      { key: "kidnap", text: "被绑架/劫持" },
      { key: "arrest", text: "被捕" },
      { key: "captured", text: "被俘" },
      { key: "strike", text: "罢工" },
      { key: "march", text: "游行" },
      { key: "rape", text: "被强奸" },
      { key: "disaster", text: "受灾" },
      { key: "infection", text: "感染" },
      { key: "involved", text: "涉案" },
      { key: "custody", text: "被扣押" },
      { key: "affect", text: "受影响" }
    ],
    commonPrefix: "event_involved_people_",
    shehuaPrefix: "event_involved_chinese_people_",
  }
};
